/**
 * Monte Carlo Config Mock
 *
 * Shows the Quanthop Monte Carlo configuration panel with
 * simulation count selector, confidence level picker, and
 * run button — mirroring the actual platform UI.
 */

const simOptions = ['100', '500', '1,000', '5,000', '10,000'];
const confOptions = ['90%', '95%', '99%', '99.9%'];

export default function MonteCarloConfigMock() {
  return (
    <div className="platform-mock">
      <div className="platform-mock-header">
        <span className="dot" /> Monte Carlo Simulation
      </div>
      <div className="platform-mock-body" style={{ padding: '0.75rem 1rem' }}>
        {/* Simulation count */}
        <div style={{ marginBottom: '0.625rem' }}>
          <div style={{ fontSize: '0.5625rem', color: '#94a3b8', marginBottom: '0.3rem' }}>
            Number of Simulations
          </div>
          <div style={{ display: 'flex', gap: '0.25rem' }}>
            {simOptions.map((opt) => (
              <div key={opt} style={{
                flex: 1,
                textAlign: 'center',
                fontSize: '0.5625rem',
                fontWeight: opt === '1,000' ? 700 : 400,
                color: opt === '1,000' ? '#e5e7eb' : '#64748b',
                background: opt === '1,000' ? '#3b82f622' : '#1e293b',
                border: opt === '1,000' ? '1px solid #3b82f666' : '1px solid #334155',
                borderRadius: 4,
                padding: '0.25rem 0.125rem',
                cursor: 'pointer',
              }}>
                {opt}
              </div>
            ))}
          </div>
        </div>

        {/* Confidence level */}
        <div style={{ marginBottom: '0.625rem' }}>
          <div style={{ fontSize: '0.5625rem', color: '#94a3b8', marginBottom: '0.3rem' }}>
            Confidence Level
          </div>
          <div style={{ display: 'flex', gap: '0.25rem' }}>
            {confOptions.map((opt) => (
              <div key={opt} style={{
                flex: 1,
                textAlign: 'center',
                fontSize: '0.5625rem',
                fontWeight: opt === '95%' ? 700 : 400,
                color: opt === '95%' ? '#e5e7eb' : '#64748b',
                background: opt === '95%' ? '#3b82f622' : '#1e293b',
                border: opt === '95%' ? '1px solid #3b82f666' : '1px solid #334155',
                borderRadius: 4,
                padding: '0.25rem 0.125rem',
                cursor: 'pointer',
              }}>
                {opt}
              </div>
            ))}
          </div>
        </div>

        {/* Input info */}
        <div style={{
          background: '#1e293b',
          border: '1px solid #334155',
          borderRadius: 4,
          padding: '0.4rem 0.5rem',
          marginBottom: '0.625rem',
        }}>
          <div style={{ fontSize: '0.5rem', color: '#64748b', marginBottom: '0.2rem' }}>Input</div>
          <div style={{ display: 'flex', justifyContent: 'space-between' }}>
            <span style={{ fontSize: '0.5625rem', color: '#94a3b8' }}>Trades from backtest</span>
            <span style={{ fontSize: '0.5625rem', color: '#e5e7eb', fontWeight: 600, fontFamily: 'ui-monospace, monospace' }}>
              87 trades
            </span>
          </div>
          <div style={{ display: 'flex', justifyContent: 'space-between', marginTop: '0.15rem' }}>
            <span style={{ fontSize: '0.5625rem', color: '#94a3b8' }}>Initial portfolio</span>
            <span style={{ fontSize: '0.5625rem', color: '#e5e7eb', fontWeight: 600, fontFamily: 'ui-monospace, monospace' }}>
              $10,000
            </span>
          </div>
        </div>

        {/* Run button */}
        <div style={{
          background: '#3b82f6',
          color: '#ffffff',
          textAlign: 'center',
          fontSize: '0.625rem',
          fontWeight: 700,
          padding: '0.35rem 0',
          borderRadius: 4,
          cursor: 'pointer',
        }}>
          Run Monte Carlo
        </div>

        {/* Output preview */}
        <div style={{
          fontSize: '0.4375rem', color: '#475569', marginTop: '0.375rem',
          textAlign: 'center', fontStyle: 'italic',
        }}>
          Produces: Return distribution, equity curve fan, drawdown distribution
        </div>
      </div>
      <div className="platform-mock-caption">
        Configure simulations and confidence level, then run directly on your backtest results.
      </div>
    </div>
  );
}
